import { render } from "./FactoryOverview.vue?vue&type=template&id=5e4bddd0"
import script from "./FactoryOverview.vue?vue&type=script&lang=js"
export * from "./FactoryOverview.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__